import { useEffect, useState } from "react";

export interface Coordinates {
  lat: number;
  lng: number;
}

const LOCAL_STORAGE_KEY = "localLocation";

export function useLocalStorageLocation() {
  const [location, setLocation] = useState<Coordinates | null>(() => {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  });

  useEffect(() => {
    const onStorageUpdate = (e: StorageEvent) => {
      if (e.key === LOCAL_STORAGE_KEY && e.newValue) {
        const newLocation: Coordinates = JSON.parse(e.newValue);
        setLocation(newLocation);
      }
    };

    const onInternalUpdate = (e: any) => {
      setLocation(e.detail); // triggered from a dispatchEvent
    };

    window.addEventListener("storage", onStorageUpdate); // cross-tab
    window.addEventListener("locationUpdated", onInternalUpdate); // same-tab

    return () => {
      window.removeEventListener("storage", onStorageUpdate);
      window.removeEventListener("locationUpdated", onInternalUpdate);
    };
  }, []);

  return location;
}